export default __webpack_public_path__ + "static/media/sample_map_dm.96349dfb.png";